<template>
    <div class="footer">
      <div class="container">
        <footer>
          <strong>Zack Ensign <span>/ Developer</span></strong>
        </footer>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Experience'
}
</script>
